export const validateCredentialId = (value: string): boolean =>
  value.length >= 8 && /^[A-Za-z0-9_-]+$/.test(value);

export const validateCredentialSecret = (value: string): boolean =>
  value.length >= 16 && /^[A-Za-z0-9+/=_-]+$/.test(value);

export const validateAuthorizationCode = (value: string): boolean =>
  value.length >= 8;

/**
 * Validates the mapping value.
 * Requirements: not empty, at least 3 characters.
 */
export const validateMappingValue = (value: string): boolean => {
  if (!value || value.trim().length === 0) {
    return false;
  }
  return value.trim().length >= 3;
};

export const CLIENT_CODE_MAX_LENGTH = 10;

export const validateClientCode = (value: string): boolean => {
  const trimmed = value?.trim() ?? '';
  return trimmed.length > 0 && trimmed.length <= CLIENT_CODE_MAX_LENGTH;
};

/**
 * Validates the claim regex (optional field).
 * If provided, should be a valid regex pattern.
 */
export const validateClaimRegex = (value: string): boolean => {
  if (!value || value.trim().length === 0) {
    return true; // Optional field
  }

  try {
    new RegExp(value);
    return true;
  } catch {
    return false;
  }
};
